import { apiClient } from './client';

export interface Coupon {
  id: string;
  code: string;
  prizeKind: string;
  amount: number;
  maxUses: number;
  usedCount: number;
  wagerMultiplier: number;
  expiresAt: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface CreateCouponBody {
  code: string;
  prizeKind: string;
  amount: number;
  maxUses?: number;
  wagerMultiplier?: number;
  expiresAt?: string | null;
  isActive?: boolean;
}

export const couponsApi = {
  list: async (): Promise<Coupon[]> => {
    const { data } = await apiClient.get('/admin/coupons');
    return data as Coupon[];
  },
  create: async (body: CreateCouponBody): Promise<Coupon> => {
    const { data } = await apiClient.post('/admin/coupons', body);
    return data as Coupon;
  },
  update: async (id: string, body: Partial<CreateCouponBody>): Promise<Coupon> => {
    const { data } = await apiClient.patch(`/admin/coupons/${id}`, body);
    return data as Coupon;
  },
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/coupons/${id}`);
  },
};
